import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MaintenanceService } from '../services/maintenance.service';
import { catchError, throwError } from 'rxjs';

/**
 * Intercepts network failures and 5xx errors to trigger Maintenance Mode.
 * This acts as a global safety net when the backend goes down or is deploying.
 */
export const maintenanceInterceptor: HttpInterceptorFn = (req, next) => {
  const maintenanceService = inject(MaintenanceService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // 0: Connection Refused / Network Error
      // 500: Internal Server Error (often returned by proxy when backend is down)
      // 502: Bad Gateway
      // 503: Service Unavailable
      // 504: Gateway Timeout
      if ([0, 500, 502, 503, 504].includes(error.status)) {
        maintenanceService.recordFailure();
      }
      return throwError(() => error);
    })
  );
};
